export default __webpack_public_path__ + "static/media/mcq.bfe706da.svg";